import React from 'react';
import { List, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';

import ContainerBox from 'components/ContainerBox';
import { useSelector } from 'react-redux';
import * as ActiveProductSelectors from 'selectors/ActiveProductSelectors';
import * as StockSelectors from 'selectors/StockSelectors';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { getSkidataSegmentNameById } from 'common/utils/segments';
import { getPricingString } from 'common/utils/common';
import { chain } from 'lodash';
import { useTranslation } from 'services/localization';

const SkidataProductPricing = () => {
	const { t } = useTranslation();

	const product = useSelector(ActiveProductSelectors.productDataWithChanges);
	const skidataSegments = useSelector(StockSelectors.liftTicketSegments);
	const currency = useSelector(ShopSelectors.getShopCurrency);

	const rows = chain(product.segmentPricings)
		.map((segmentPricing) => ({
			name: getSkidataSegmentNameById(segmentPricing.segments[0], skidataSegments ?? []),
			price: segmentPricing.fixedPrice || 0,
		}))
		.sortBy('name')
		.value();

	return (
		<ContainerBox>
			<List>
				<ListItem divider>
					<ListItemText
						primary={t('pricing.segment', 'Segment')}
						primaryTypographyProps={{ variant: 'body2' }}
					/>
					<ListItemSecondaryAction>
						<Typography variant="body2">{t('pricing.price', 'Price')}</Typography>
					</ListItemSecondaryAction>
				</ListItem>
				{rows.map((row, index) => {
					return (
						<ListItem divider={index !== rows.length - 1} key={row.name}>
							<ListItemText primary={row.name} />
							<ListItemSecondaryAction>
								<Typography>{getPricingString(row.price, currency)}</Typography>
							</ListItemSecondaryAction>
						</ListItem>
					);
				})}
			</List>
		</ContainerBox>
	);
};

export default SkidataProductPricing;
